import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withKeys as _withKeys, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "KUSY", -1)
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = { class: "flex grid" }
const _hoisted_6 = { class: "field grid col-12 md:col-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "item-category",
  class: "col-12 md:col-2 md:mb-0"
}, "Kategória", -1)
const _hoisted_8 = { class: "col-12 md:col-10 flex align-items-center justify-content-between gap-1" }
const _hoisted_9 = {
  key: 0,
  class: ""
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "field grid col-12 md:col-6" }
const _hoisted_13 = { class: "col-12 flex justify-content-end" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search mr-2" }, null, -1)
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "grid" }
const _hoisted_17 = { class: "grid w-full h-full" }
const _hoisted_18 = { class: "col-6 p-2" }
const _hoisted_19 = { class: "text-left font-bold" }
const _hoisted_20 = { class: "text-left mt-5" }
const _hoisted_21 = { class: "col-6 p-1 flex justify-content-center" }
const _hoisted_22 = { class: "w-full h-full flex justify-content-center align-items-center" }
const _hoisted_23 = ["src", "onLoad"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PrimevueDialog = _resolveComponent("PrimevueDialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/mod-stock/stock-items/0",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimevueButton, {
                label: "Pridať kus",
                severity: "success",
                icon: "pi pi-plus",
                text: "",
                raised: "",
                class: "uppercase"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/mod-stock/bulk-add-items",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimevueButton, {
                label: "Pridanie kusov",
                severity: "success",
                icon: "pi pi-plus",
                text: "",
                raised: "",
                class: "uppercase"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/mod-stock/scan-item",
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimevueButton, {
                label: "Skenovať kus",
                severity: "success",
                icon: "pi pi-camera",
                text: "",
                raised: "",
                class: "uppercase"
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_DataTable, {
        lazy: "",
        paginator: "",
        rows: this.pagination.rows,
        onPage: $options.onPage,
        first: this.pagination.first,
        loading: $data.loading,
        totalRecords: this.pagination.totalRecords,
        dataKey: "id",
        value: this.stockItems,
        filters: $data.filters,
        "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (($data.filters) = $event)),
        onFilter: $options.onFilter,
        filterDisplay: "row",
        globalFilterFields: $data.globalFilterFields,
        stripedRows: "",
        "row-hover": "",
        scrollable: "",
        selection: this.selectedStockItem,
        "onUpdate:selection": _cache[5] || (_cache[5] = ($event: any) => ((this.selectedStockItem) = $event)),
        selectionMode: "single",
        metaKeySelection: false,
        onRowSelect: _cache[6] || (_cache[6] = ($event: any) => ($options.showDetail(this.selectedStockItem.id))),
        tableStyle: "min-width: 50rem",
        virtualScrollerOptions: { itemSize: 100 },
        scrollHeight: `${this.vh - 420}px`
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_PrimevueSelect, {
                  id: "item-category",
                  modelValue: this.selectedCategory,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.selectedCategory) = $event)),
                  options: this.categories,
                  optionLabel: "name",
                  placeholder: "Výberom kategórie sa zobrazí tabuľka produktov",
                  class: "w-full",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => ($options.filterProducts(this.selectedCategory.id)))
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"]),
                (this.selectedCategory)
                  ? _withDirectives((_openBlock(), _createBlock(_component_PrimevueButton, {
                      key: 0,
                      type: "button",
                      class: "",
                      icon: "pi pi-filter-slash",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.cancelSelect())),
                      text: ""
                    }, null, 512)), [
                      [
                        _directive_tooltip,
                        { value: 'Zrušenie výberu' },
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_IconField, {
                  iconPosition: "left",
                  class: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputIcon, null, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_InputText, {
                      modelValue: $data.filters['global'].value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.filters['global'].value) = $event)),
                      placeholder: "Vyhľadať",
                      onKeydown: _withKeys($options.onFilter, ["enter"])
                    }, null, 8, ["modelValue", "onKeydown"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("img", {
                src: `${slotProps.data.product.image}`,
                alt: slotProps.data.product.image,
                class: "shadow-4 border-round",
                width: "64"
              }, null, 8, _hoisted_15)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "",
            style: {"min-width":"5%"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", {
                class: "color-box",
                style: _normalizeStyle({ backgroundColor: slotProps.data.color.colorHash })
              }, null, 4)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "code",
            header: "Kód",
            filterField: "productNumber",
            showFilterMenu: false,
            filterMenuStyle: { width: '6rem' },
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.code), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"5rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "product.category.name",
            header: "Kategória",
            filterField: "categoryName",
            showFilterMenu: false,
            filterMenuStyle: { width: '6rem' },
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.product.category.name), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_PrimevueSelect, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                onChange: ($event: any) => (filterCallback()),
                options: this.categories,
                optionLabel: "name",
                placeholder: "Vyber kategóriu",
                class: "p-column-filter",
                style: {"min-width":"6rem"}
              }, {
                option: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.option.name), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "product.name",
            header: "Názov",
            filterField: "productName",
            showFilterMenu: false,
            filterMenuStyle: { width: '6rem' },
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.product.name), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"6rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "length",
            header: "Dĺžka",
            filterField: "productLength",
            showFilterMenu: false,
            filterMenuStyle: { width: '4rem' },
            style: {"min-width":"5%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.length), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "comment",
            header: "Poznámka",
            filterField: "comment",
            showFilterMenu: false,
            filterMenuStyle: { width: '5rem' },
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.comment), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"6rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "location",
            header: "Umiestnenie",
            filterField: "location",
            showFilterMenu: false,
            filterMenuStyle: { width: '5rem' },
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.location), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"6rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "color.code",
            header: "Farba",
            filterField: "color",
            showFilterMenu: false,
            filterMenuStyle: { width: '5rem' },
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.color ? slotProps.data.color.code : ""), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"6rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "",
            header: "Objednávka",
            filterField: "orderCode",
            showFilterMenu: false,
            filterMenuStyle: { width: '4rem' },
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.order ? slotProps.data.order.orderCode : ""), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"4rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "order.customerLastName",
            header: "Zákazník",
            filterField: "customer",
            showFilterMenu: false,
            filterMenuStyle: { width: '6rem' },
            style: {"min-width":"10%"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.order ? slotProps.data.order.customerLastName : ""), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať",
                style: {"min-width":"6rem"}
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode(_component_PrimevueButton, {
                type: "button",
                icon: "pi pi-trash",
                onClick: ($event: any) => ($options.confirmDelete(slotProps.data.id)),
                text: "",
                severity: "danger",
                size: "small"
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  { value: 'Vymazanie produktu' },
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rows", "onPage", "first", "loading", "totalRecords", "value", "filters", "onFilter", "globalFilterFields", "selection", "scrollHeight"]),
      _createVNode(_component_PrimevueDialog, {
        visible: this.visibleProducts,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((this.visibleProducts) = $event)),
        header: "Produkty",
        style: { width: '60rem' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.products, (prod, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "p-1 sm:col-12 md:col-4 lg:col-4 xl:col-4"
              }, [
                _createVNode(_component_PrimevueButton, {
                  outlined: "",
                  class: "p-1",
                  onClick: ($event: any) => ($options.setSelectProduct(prod) ),
                  onMouseover: ($event: any) => (this.hoverIndex = index),
                  onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (this.hoverIndex = null)),
                  style: _normalizeStyle($options.buttonStyle(index))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(prod.code), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(prod.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("img", {
                            src: prod.image,
                            style: _normalizeStyle(`${prod.imageHeight >= prod.imageWidth ? 'height:168px;' : 'width:140px;'}`),
                            onLoad: ($event: any) => ($options.checkImageSize(index,$event)),
                            alt: "Preview Image",
                            class: ""
                          }, null, 44, _hoisted_23)
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick", "onMouseover", "style"])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}